// extracted by mini-css-extract-plugin
export default {"tabContainer":"filterTab_tabContainer__pog5M","removeIcon":"filterTab_removeIcon__NGKht"};